// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dp-2";
export var aiChatCartContainerExit = "_dp-4";
export var aiChatContainerLarge = "_dp-0";
export var aiChatContainerSmall = "_dp-1";
export var aiChatIcon = "_dp-6";
export var slideInFromRight = "_dp-3";
export var slideOutToRight = "_dp-5";